/**
 * Shared utility functions for string manipulation and validation.
 *
 * @module Utils
 * @packageDocumentation
 */
/**
 * Check if a string is a decimal number (e.g., "1", "137").
 *
 * @param value - The string to check
 * @returns True if the string contains only digits
 *
 * @example
 * ```typescript
 * isDecimalString("123")  // true
 * isDecimalString("0x1")  // false
 * isDecimalString("abc")  // false
 * ```
 */
export function isDecimalString(value) {
    return /^[0-9]+$/.test(value);
}
/**
 * Check if a string is a hexadecimal number (e.g., "0x1", "0x89").
 *
 * @param value - The string to check
 * @returns True if the string is a valid hex format with 0x prefix
 *
 * @example
 * ```typescript
 * isHexString("0x1")    // true
 * isHexString("0xABC")  // true
 * isHexString("123")    // false
 * isHexString("0x")     // false
 * ```
 */
export function isHexString(value) {
    return /^0x[0-9a-f]+$/i.test(value);
}
/**
 * Convert a hex string to decimal string.
 *
 * @param hex - The hex string to convert (with 0x prefix)
 * @returns The decimal string representation
 *
 * @example
 * ```typescript
 * hexToDecimalString("0x1")   // "1"
 * hexToDecimalString("0x89")  // "137"
 * hexToDecimalString("0xFF")  // "255"
 * ```
 */
export function hexToDecimalString(hex) {
    return Number.parseInt(hex, 16).toString();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbWFpbi9zaGFyZWQvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7O0dBS0c7QUFFSDs7Ozs7Ozs7Ozs7O0dBWUc7QUFDSCxNQUFNLFVBQVUsZUFBZSxDQUFDLEtBQWE7SUFDM0MsT0FBTyxVQUFVLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ2hDLENBQUM7QUFFRDs7Ozs7Ozs7Ozs7OztHQWFHO0FBQ0gsTUFBTSxVQUFVLFdBQVcsQ0FBQyxLQUFhO0lBQ3ZDLE9BQU8sZ0JBQWdCLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ3RDLENBQUM7QUFFRDs7Ozs7Ozs7Ozs7O0dBWUc7QUFDSCxNQUFNLFVBQVUsa0JBQWtCLENBQUMsR0FBVztJQUM1QyxPQUFPLE1BQU0sQ0FBQyxRQUFRLENBQUMsR0FBRyxFQUFFLEVBQUUsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDO0FBQzdDLENBQUMifQ==